import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from '~/app/theme';
import { Icon } from './Icon';
import { cn } from '~/utils';

export const ThemeToggle = ({
  className,
}: {
  className?: string;
}): ReactElement => {
  const { theme, toggleTheme } = useTheme();
  const { t } = useTranslation('common');
  const isDark = theme === 'dark';

  return (
    <button
      aria-label={isDark ? t('switchToLightTheme') : t('switchToDarkTheme')}
      className={cn(
        'inline-flex min-h-9 min-w-9 items-center justify-center rounded-full border border-border bg-elevated text-muted transition hover:bg-hover hover:text-foreground focus-visible:outline-2 focus-visible:outline-primary',
        className
      )}
      onClick={toggleTheme}
      type="button"
    >
      <Icon className="size-[18px]" name={isDark ? 'sun' : 'moon'} />
    </button>
  );
};
